import initialState from './NotificationsInitialState';
import reducers from './NotificationsReducer';

export default {
  initialState,
  reducers,
};
